import Box from '@mui/material/Box';
import { SecondaryMenuWrapper } from '../component';
import { CHAT_BOT_HEIGHT } from '../component/ChatBotSpaceHolder';
import { useTranslation } from 'react-i18next';
import type { RootState } from '../../grid/reduxStore/Store';
import { useSelector } from 'react-redux';
import { CustomFieldsSection } from '../CustomFieldsSection/CustomFieldsSection';
import { FeatureFlags } from '../../../../utils/featureFlags.ts';
import useFeatureFlag from '../../../../hooks/useFeatureFlag.ts';
import { useListCurrencyQuery } from '../../../../pages/editor/useListCurrencyQuery.tsx';
import CurrencyAutocomplete from '../DocumentSettings/CurrencyAutocomplete/CurrencyAutocomplete.tsx';

export function TemplateSettings({ contentId }: { contentId: string }) {
  const { t } = useTranslation();
  const { data: currencies, isLoading, error } = useListCurrencyQuery();
  const { isAdvancedSpacingModelOpen } = useSelector((state: RootState) => state.blockStyleSettings);

  const evaluateFeatureFlag = useFeatureFlag([FeatureFlags.currencySettings]);
  const isCurrencySettingsEnabled = evaluateFeatureFlag[FeatureFlags.currencySettings] && !error && !isLoading;

  if (isAdvancedSpacingModelOpen) return null;

  return (
    <SecondaryMenuWrapper testId={'template-settings-component'}>
      <Box
        sx={(theme) => ({
          height: '100%',
          overflowY: 'auto',
          pt: 1.5,
          pb: `calc(${CHAT_BOT_HEIGHT} + ${theme.spacing(3)})`,
        })}
      >
        {isCurrencySettingsEnabled && (
          <CurrencyAutocomplete currencies={currencies} autocompleteTitle={t('document.currency.template_currency')} />
        )}

        <CustomFieldsSection level="template" id={contentId} />
      </Box>
    </SecondaryMenuWrapper>
  );
}
